import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  searchContainer: {
    overflow: "auto",
    // padding: "1rem",
    display: "flex",
    maxHeight: "70vh",
    // "& .MuiGrid-container":{
    //   minHeight: "26.5rem"
    // }
    "&  .MuiInputBase-root": {
      [theme.breakpoints.down("md")]: {
        background: `${theme?.palette?.casinoSearch?.inputBG} !important`,
        paddingRight: "20px !important"
      }
    },
    // "& .MuiButtonBase-root": {
    //   height: "40px",
    // },
    "& .MuiAccordionDetails-root": {
      background: theme?.palette?.casinoSearch?.primaryBG
    }
  },

  category: {
    background: theme?.palette?.primaryBG?.[400],
    padding: "0 1rem 1rem 1rem",
    "& .MuiButtonBase-root": {
      height: "30px",
      background: theme?.palette?.casinoSearch?.inputBG
    }
  },
  search: {
    // paddingLeft: "0.5rem",
    padding: "20px 15px",
    display: "flex",
    flexDirection: "column",
    rowGap: "0.5rem",
    minHeight: "500px",
    background: theme?.palette?.primaryBG?.[400],
    "& .MuiButtonBase-root": {
      width: "100%"
    }
    // "& button": {
    //   minHeight: "52px"
    // }
  },

  selectemItemBtn: {
    marginTop: "10px",
    textTransform: "none"
  },
  searchGames: {
    minHeight: "23rem",
    margin: "0",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  headerSearch: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    "& .MuiTextField-root": {
      width: "100%"
    },
    "& .MuiInputBase-root": {
      borderRadius: "10px",
      background: theme?.palette?.casinoSearch?.inputBG,
      color: theme?.palette?.primaryText?.[100],
      height: "52px",
      fontSize: "14px",
      [theme.breakpoints.down("md")]: {
        background: "transparent",
        padding: "0"
      }
    },
    "& img,svg": {
      top: "0px",
      right: "10px",
      position: "absolute",
      bottom: "0px",
      margin: "auto"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    }
  },
  searchImg: {
    margin: "40px 0",
    textAlign: "center",

    "& img,svg": {
      width: "340px",
      [theme.breakpoints.down("sm")]: {
        width: "250px"
      }
    },
    "& .MuiTypography-h6": {
      [theme.breakpoints.down("md")]: {
        background: "transparent",
        fontSize: "16px",
        textAlign: "center",
        padding: "0 10px"
      }
    }
  },
  btnPrimary: {
    borderRadius: "10px",
    background: theme?.palette?.secondaryBG?.red,
    padding: "14px 20px",
    color: `${theme?.palette?.secondaryText?.[700]} !important`,
    fontSize: "14px",
    fontWeight: "700",
    textTransform: "capitalize",
    height: "50px",
    "&:hover": {
      background: theme?.palette?.primaryBG?.[650],
      color: theme?.palette?.primaryText?.[100]
    }
  },
  loadMoreButton: {
    margin: "40px 0",
    width: "fit-content !important"
  },
  moreGamesLoader: {
    marginTop: "40px",
    color: theme?.palette?.primary2TextColor?.main
  },
  accordiondetails: {
    "& .MuiButtonBase-root": {
      height: "auto"
    }
  },
  searchLoader: {
    color: theme?.palette?.primary2TextColor?.main
  },
  serachWrapper: {
    position: "sticky",
    marginTop: "15px",
    top: "15px"
  },

  modalGame: {
    display: "grid",
    "& .modalGameList": {
      // "& img[alt='Heart']": {
      //   top: "-20px !important",
      //   bottom: "auto",
      //   width: "25px",
      //   right: "20px !important",
      //   position: "absolute !important",
      //   left: "inherit",
      // },
      // "& button": {
      //   width: "100% !important",
      // },
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fill,minmax(calc(16.66667% - 8.33333px),1fr))",
      "& .favCard": {
        marginRight: "0"
      },
      [theme.breakpoints.down("xl")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(19.66667% - 8.33333px),1fr))"
      },
      [theme.breakpoints.down("lg")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(16.66667% - 8.33333px),1fr))"
      },
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(32.66667% - 8.33333px),1fr))"
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(49.66667% - 8.33333px),1fr))"
      }
    }
  },
  categoryLoader: {
    margin: "40px",
    color: theme?.palette?.primary2TextColor?.main
  }
}));
